import React from 'react';
import { Panel } from '@cloudsam/ui';

/**
 * ExplorerHeader — the "Context" panel.
 *
 * Was a slim selector row (WP-SE-46, 2026-05-18); rebuilt as a <Panel> per
 * surface-identity-and-shell.md §6 item 4. It carries the Survey / Deployment
 * selects on the left and the Statistical Summary N-counts on the right.
 *
 * `status` holds the History / Live readouts, which moved here out of the
 * toolbar band (§6 item 3 — "status readouts belong in the panel, not the
 * band; the band carries controls").
 */
export default function ExplorerHeader({ deploymentSelector, statisticalSummary, status }) {
    return (
        <Panel
            title="Context"
            actions={status}
            className="explorer-context"
            bodyStyle={{
                display: 'flex',
                alignItems: 'flex-end',
                justifyContent: 'space-between',
                gap: 'var(--spacing-base)',
                padding: 'var(--spacing-sm) var(--spacing-base)',
                overflow: 'visible',
            }}
        >
            <div style={{ display: 'flex', alignItems: 'flex-end', gap: 'var(--spacing-base)', minWidth: 0 }}>
                {deploymentSelector}
            </div>
            <div style={{ flexShrink: 0 }}>{statisticalSummary}</div>
        </Panel>
    );
}
